/**
 * Added the following method to policySubPages using vue mixins
 * @see https://vuejs.org/v2/guide/mixins.html
 */
export default {
  methods: {
    hasVirtualLocation(policy) {
      return policy
        ? policy.first_location
          ? policy.locations.filter((loc) => loc.type === "virtual").length > 0
          : false
        : false;
    },
  },
};
